import React, { useCallback, useState, useEffect } from "react";

import { putItem } from "../../../../utils/api";

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "../../styles/MatchListItem.css";

const TeamSelect = ({ matchDay }) => {
    const [selectedTeam, setSelectedTeam] = useState(null);
    const teams = useSelector((state) => state.teamsReducer.data);
    const [loading, setIsLoading] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        teams.map((team) => {
            if (team.id == matchDay?.matchDayOfficialTeam) {
                setSelectedTeam(team);
            }
        });
    }, [teams, matchDay]);

    const handleTeamChange = useCallback(
        async (team) => {
            setIsLoading(true);
            const endpoint = `/admin/api/dhbmatchdays/${matchDay?.matchDayKey}`;
            try {
                const response = await putItem(endpoint, {
                    matchDayOfficialTeam: team.id,
                });

                setIsLoading(false);
                setSelectedTeam(team);
            } catch (error) {
                setIsLoading(false);
                console.log(error.message);
            }
        },
        [matchDay]
    );

    return (
        <div className="team-select-wrap">
            <Autocomplete
                id="auto-complete"
                options={teams || []}
                getOptionLabel={(option) => {
                    if (!option) return "";
                    return option.name;
                }}
                autoComplete
                includeInputInList
                disableClearable
                onChange={(_, value) => handleTeamChange(value)}
                value={selectedTeam}
                loading={loading}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={t(
                            "dhb.leaguemgmt.planner.tournament.management"
                        )}
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {loading ? (
                                        <CircularProgress
                                            color="inherit"
                                            size={20}
                                        />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                    />
                )}
            />
        </div>
    );
};

export default TeamSelect;
